module.exports = __webpack_public_path__ + "static/media/icon-vip.1af83c23.svg";